@if ({
    currentBlacklist: currentBlacklist$ | async,
    customerList: customerList$ | async,
    jobseekerIgnoredCustomerList: jobseekerIgnoredCustomerList$ | async
}; as data) {
    <div class="blacklist">
        <div class="blacklist__body">
            <div class="customers">
                <label class="customers__search">
                    <svg-icon class="customers__search-icon" src="/assets/icons/search-outline.svg" [svgClass]="'customers__search-svg'"></svg-icon>
                    <input class="customers__search-input" type="text" (input)="onCustomerSearchChange($any($event.target).value)" />
                </label>

                <div class="customers__list">
                    @for (customer of data.customerList; track customer.value) {
                        <button type="button" class="customers__item" (click)="onSelectCustomer(customer)">{{ customer.name }}</button>
                    }
                </div>
            </div>

            <div class="selected">
                <div class="selected__list" #selectedCustomers>
                    @for (customer of data.jobseekerIgnoredCustomerList; track customer.value) {
                        <span class="selected__item">
                            {{ customer.name }}
                            <button type="button" class="selected__remove" [attr.aria-label]="'label.Delete' | translate" (click)="removeSelectedCustomer(customer)">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                                    <path d="M1 1 11 11M11 1 1 11" stroke="#E53935" stroke-width="1.6" stroke-linecap="round" />
                                </svg>
                            </button>
                        </span>
                    }
                </div>

                <p class="selected__text" #text>{{ 'text.BlacklistDescription' | translate }}</p>
            </div>
        </div>

        <div class="blacklist__buttons">
            <button type="button" class="blacklist__save" (click)="onSave(data.currentBlacklist)">{{ 'label.Save' | translate }}</button>
            <button type="button" class="blacklist__cancel" (click)="onCancel()">{{ 'label.Cancel' | translate }}</button>
        </div>
    </div>
}
